import { render, staticRenderFns } from "./DashboardAudition.vue?vue&type=template&id=00191994&"
import script from "./DashboardAudition.vue?vue&type=script&lang=ts&"
export * from "./DashboardAudition.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardAudition.vue?vue&type=style&index=0&id=00191994&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports